// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__1W7Ej","inputDescription":"styles_inputDescription__5tkWm"};